module.exports = __webpack_public_path__ + "img/link04.87584345.png";